import BarrierDialog, { BarrierDialogFields } from "./BarrierDialog";

export { type BarrierDialogFields };
export default BarrierDialog;